import { useMutation } from '@tanstack/react-query';
import { fetchKit } from '../lib/api';
import type { KitRequest, KitResponse } from '@nfa/types';

export function useKit() {
  return useMutation<KitResponse, Error, KitRequest>({
    mutationFn: fetchKit,
  });
}
